export class LocalizeConfig {
  jsonPath = '/assets/i18n/';
  fallbackCulture = 'it-IT';
}
